import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-case-edit-details',
  templateUrl: './case-edit-details.component.html',
  styleUrls: ['./case-edit-details.component.scss']
})
export class CaseEditDetailsComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

}
